import { render, staticRenderFns } from "./UserProfileNewUserSubscriptions.vue?vue&type=template&id=1b615260"
import script from "./UserProfileNewUserSubscriptions.vue?vue&type=script&lang=js"
export * from "./UserProfileNewUserSubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports